module.exports = __webpack_public_path__ + "static/media/AtRest.d9782e14.png";